import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
    constructor(private snackBar: MatSnackBar) {}

    openError(message: string): void {
        this.snackBar.open(message, 'Close', {
            duration: 5000, // 5 seconds
            panelClass: ['error-toast'], // Custom CSS class for styling
        });
    }

    openSuccess(message: string): void {
        this.snackBar.open(message, 'Close', {
            duration: 5000, // 5 seconds
            panelClass: ['error-toast'], // Custom CSS class for styling
        });
    }
}
